import _objectSpread from "/data/jenkins/workspaces/workspace/h5/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import vueQr from 'vue-qr';
import cache from '@/utils/cache';
import { parseUrl } from '@/utils/tools';
import qrMinxin from './qr_mixin';
import '@/utils/buildwebBridge';
import { getCountryCode as _getCountryCode, createPictureCode, checkPictureCode, getVerificationCode, loginByMobile, qlogin } from '@/api/phoneLogin';
export default {
  components: {
    vueQr: vueQr
  },
  mixins: [qrMinxin],
  data: function data() {
    var _this = this;

    var validatePhone = function validatePhone(rule, value, callback) {
      if (!value) {
        _this.loadingDisabled = true;
        _this.count.phone = false;
        callback();
      } else if (_this.selectCode === '+86' && !/^\d{11}$/.test(value)) {
        _this.loadingDisabled = true;
        _this.count.phone = false;

        if (_this.phoneActive || _this.phoneState) {
          callback();
        } else {
          callback(new Error('手机号码格式错误'));
        }
      } else if (_this.selectCode !== '+86' && !/^\d{7,11}$/.test(value)) {
        _this.loadingDisabled = true;
        _this.count.phone = false;

        if (_this.phoneActive) {
          callback();
        } else {
          callback(new Error('手机号码格式错误'));
        }
      } else {
        _this.count.phone = true;

        if (!_this.isCountdownIng && _this.showCheckPic && _this.count.picNum) {
          _this.loadingDisabled = false;
        } else {
          _this.loadingDisabled = true;
        }

        callback();
      }
    };

    var validatePicNum = function validatePicNum(rule, value, callback) {
      if (!value) {
        _this.loadingDisabled = true;
        _this.count.picNum = false;
        _this.picCodeWrong = false;
        callback();
      } else if (!/^[0-9a-zA-Z]{4}$/.test(value)) {
        _this.loadingDisabled = true;
        _this.count.picNum = false;
        _this.picCodeWrong = false;

        if (_this.pictureActive) {
          callback();
        } else {
          callback(new Error('图形验证码格式错误'));
        }
      } else {
        _this.count.picNum = true;

        if (_this.showCheckPic && _this.count.phone && !_this.isCountdownIng) {
          _this.loadingDisabled = false;
        } else {
          _this.loadingDisabled = true;
        }

        callback();
      }
    };

    var validateCode = function validateCode(rule, value, callback) {
      // this.inputed = false
      if (value === '') {
        _this.count.code = false;
        _this.codeError = false;
        callback();
      } else if (!/^\d{6}$/.test(value)) {
        _this.count.code = false;

        if (_this.codeActive) {
          _this.codeError = false;
          callback();
        } else {
          _this.codeError = true;
          callback(new Error('短信验证码错误'));
        }
      } else {
        _this.count.code = true;
        _this.codeError = false;
        callback();
      }
    };

    return {
      loginForm: {
        phone: '',
        picNum: '',
        code: ''
      },
      rules: {
        phone: [{
          validator: validatePhone,
          trigger: ['blur', 'change']
        }],
        picNum: [{
          validator: validatePicNum,
          trigger: ['blur', 'change']
        }],
        code: [{
          validator: validateCode,
          trigger: ['blur', 'change']
        }]
      },
      // 表单是否符合填写规则
      count: {
        phone: false,
        picNum: false,
        code: false
      },
      loadingDisabled: true,
      verificationText: '获取验证码',
      attributeloading: 'cur',
      // 动态绑定属性
      eliconloading: 'el-icon-loading',
      isCountdownIng: false,
      picUrl: '',
      showCheckPic: false,
      // 图片验证码校验标识
      picCodeWrong: false,
      domains: [],
      wudomain: '',
      reqFlag: 0,
      url: '',
      reqUrlPath: '',
      jumpUrl: '',
      domLoad: false,
      loginText: '登录',
      phoneActive: false,
      // 手机号输入框是否获取焦点
      pictureActive: false,
      // 图片验证码输入框是否获取焦点
      codeActive: false,
      // 短信验证码输入框是否获取焦点
      selectCode: '+86',
      // 区号
      areaCodeList: [],
      // 国际区号列表
      codeError: false,
      // 验证码是否符合规则
      sendAgain: false,
      phoneState: false,
      // 是否支持密码登录
      enablePasswordLogin: true,
      isGetUseInfo: false,
      loginKey: '',
      realName: '',
      headImg: '',
      userName: ''
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['appConfig'])), {}, {
    confirmDisabled: function confirmDisabled() {
      return !(this.count.phone && this.count.code);
    }
  }),
  watch: {
    'loginForm.phone': function loginFormPhone(value) {
      this.loginForm.phone = this.loginForm.phone.replace(/\D/g, '');

      if (this.selectCode === '+86' && /^\d{11}$/.test(value) || this.selectCode !== '+86' && /^\d{7,11}$/.test(value)) {
        this.phoneState = true;
      } else {
        this.phoneState = false;
      }
    },
    'loginForm.code': function loginFormCode() {
      this.loginForm.code = this.loginForm.code.replace(/\D/g, '');
    },
    'appConfig.enablePasswordLogin': function appConfigEnablePasswordLogin(bool) {
      this.enablePasswordLogin = bool;
    }
  },
  created: function created() {
    var _this2 = this;

    this.$utils.zhugeTrack('web-访问-登录页-PV');
    !this.isQrLogin && this.getCountryCode();
    !this.isQrLogin && this.getPicCodeAjax();
    this.isQrLogin && this.refreshQr();

    try {
      window.allCallBackByPc = function (data) {
        console.log('allCallBackByPc数据', data, process.env.VUE_APP_MODE);
        _this2.isQrLogin && _this2.refreshQr();
        if (process.env.VUE_APP_MODE !== data.env) return;

        if (data && data.success === true) {
          _this2.realName = data.realName;
          _this2.headImg = data.headImg;
          _this2.userName = data.userName;
          _this2.isGetUseInfo = true;
        } else {
          _this2.isGetUseInfo = false;
        }
      };

      window.allCallSso = function (data) {
        console.log('allCallSso数据', data);
        _this2.loginKey = data.loginKey;

        _this2.qlogins();
      };
    } catch (error) {
      console.log(error);
    }
  },
  mounted: function mounted() {
    // 初始化设置：知否支持密码登录，接口配置由watch监听更新
    this.enablePasswordLogin = cache.get('enablePasswordLogin');
  },
  methods: {
    /**
     * @func 获取国际区号
     */
    getCountryCode: function getCountryCode() {
      var _this3 = this;

      _getCountryCode().then(function (res) {
        var _ref = res || {},
            code = _ref.code,
            data = _ref.data,
            message = _ref.message;

        if (code === '1') {
          _this3.areaCodeList = data;
        } else {
          _this3.$message.error(message);
        }
      }).catch(function (e) {
        console.log(e);
      });
    },

    /**
     * @func 获取图片验证码
     */
    getPicCodeAjax: function getPicCodeAjax() {
      var _this4 = this;

      this.$set(this, 'showCheckPic', false);
      this.$set(this.loginForm, 'picNum', '');
      createPictureCode().then(function (data) {
        var imgBase64 = "data:image/png;base64,".concat(_this4.toBase64(data));

        if (imgBase64 === process.env.VUE_APP_VERIFY_CODE_BUSY) {
          _this4.$message.warning('获取图片验证码操作频繁，请您稍后再试！');
        } else {
          _this4.picUrl = imgBase64;
        }
      }).catch(function (e) {
        console.log(e);
      });
    },

    /**
     * @func 用户输入，校验图片验证码
     * @desc 验证码位数4位
     */
    changePicCode: function changePicCode(code) {
      var _this5 = this;

      // 如果不是4位，直接提示格式错误
      if (code.length !== 4) {
        this.showCheckPic = false;
        this.picCodeWrong = false;
        this.loadingDisabled = true;
        return;
      }

      checkPictureCode({
        imgCode: this.loginForm.picNum
      }).then(function (res) {
        var _ref2 = res || {},
            respCode = _ref2.respCode;

        _this5.showCheckPic = true;

        if (respCode && respCode.code === '1') {
          _this5.picCodeWrong = false;
          _this5.loadingDisabled = !(_this5.count.phone && !_this5.isCountdownIng);
        } else {
          _this5.picCodeWrong = true;
          _this5.loadingDisabled = true;
        }
      }).catch(function (e) {
        console.log('校验图片验证码异常', e);
      });
    },

    /**
     * @func 获取语音验证码
     */
    getPicMessageCode: function getPicMessageCode() {
      var _this6 = this;

      this.$confirm('我们将以电话形式告知验证码，你可能会接到010、0551、024、029等开头的来电，请放心接听。', '语音验证码', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '获取',
        cancelButtonText: '取消',
        customClass: 'customer-confirm',
        closeOnClickModal: false
      }).then(function () {
        _this6.sendMessageCode(true);
      });
    },

    /**
     * @func 发送手机验证码
     * @desc 图片验证码校验成功
     */
    sendMessageCode: function sendMessageCode(type) {
      var _this7 = this;

      if (!navigator.onLine) {
        return this.$message.warning('当前网络不可用，请检查网络设置');
      }

      this.attributeloading = 'icon';
      this.verificationText = '';
      this.loadingDisabled = true; // 获取验证码

      getVerificationCode({
        mobile: this.loginForm.phone,
        imageCode: this.loginForm.picNum,
        phoneAreaCode: this.selectCode,
        sendByVoice: type,
        mode: 'login'
      }).then(function (res) {
        var _ref3 = res || {},
            code = _ref3.code,
            message = _ref3.message;

        if (code === '1') {
          _this7.$message.success("\u53D1\u9001\u6210\u529F\uFF0C\u8BF7".concat(type ? '等待来电' : '注意查收'));

          _this7.countdownFn(60);
        } else {
          _this7.handleVerifyCodeError(message);
        }
      }).catch(function (err) {
        console.warn('获取验证码失败', err);

        _this7.handleVerifyCodeError();
      });
    },

    /**
     * @func 手机/语音验证码发送失败错误处理
     */
    handleVerifyCodeError: function handleVerifyCodeError(message) {
      this.attributeloading = 'cur';
      this.loginForm.picNum = '';
      this.verificationText = "\u91CD\u65B0\u83B7\u53D6";
      this.sendAgain = true;
      this.loadingDisabled = false;
      this.showCheckPic = false;
      this.getPicCodeAjax();
      message && this.$message.error(message);
    },

    /**
     * @func 倒计时函数
     * @desc 为什么不写个干净的倒计时呢。。。
     * @desc 默认60s
     */
    countdownFn: function countdownFn() {
      var _this8 = this;

      var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 60;
      this.sendAgain = false;
      this.isCountdownIng = false;
      this.loadingDisabled = true;
      var remain = parseInt(count);
      var setTimer = window.setInterval(function () {
        if (remain > 0) {
          remain--;
          _this8.attributeloading = 'cur';
          _this8.verificationText = "\u91CD\u65B0\u83B7\u53D6(".concat(remain < 10 ? '0' + remain : remain, ")");
        } else {
          _this8.verificationText = '获取验证码';
          _this8.loadingDisabled = false;
          _this8.isCountdownIng = false;
          clearTimeout(setTimer);
        }
      }, 1000);
    },

    /**
     * @func 用户点击登录，或者敲击enter键
     */
    confirm: function confirm() {
      var _this9 = this;

      // 禁止提交时，敲击enter，取消响应
      if (this.confirmDisabled) return; // 离线，提交不可用

      if (!navigator.onLine) {
        return this.$message.warning('当前网络不可用，请检查网络设置');
      } // 重置状态--防止二维码扫描污染数据


      this.reset(); // 执行登录

      this.loginText = '登录中...';
      var _this$loginForm = this.loginForm,
          phone = _this$loginForm.phone,
          code = _this$loginForm.code;

      var _parseUrl = parseUrl(window.location.href),
          sysCode = _parseUrl.sysCode;

      loginByMobile({
        mobile: phone,
        validateCode: code,
        phoneAreaCode: this.selectCode,
        service: this.service,
        sysCode: sysCode || '',
        forYts: this.isYTS
      }, this.service).then(function (res) {
        // 【注意】服务端短信动态码的redirect url在内层，账号密码登录，二维码登录在外层。
        var code = res.code,
            data = res.data,
            message = res.message;

        if (code === '1') {
          // 登录成功
          _this9.handleLoginSuccess(data);
        } else if (code === '3011') {
          // 补充手机号
          _this9.bindPhone(data.userName);
        } else if (code === '3012' || code === '3013' || code === '3014') {
          // 账号探活
          _this9.oaProbe(data, code, data.url);
        } else if (code === '5204') {
          // 二次认证
          _this9.doubleVerify(data, message, 'smsLogin');
        } else {
          _this9.handleLoginError(message);
        }
      }).catch(function (err) {
        _this9.handleLoginError(err.message);
      }).finally(function () {
        _this9.loginText = '登录';
      });
    },

    /**
     * @func 短信登录成功后续逻辑
     */
    handleLoginSuccess: function handleLoginSuccess(data) {
      data.domains && (this.domains = decodeURIComponent(data.domains).split(','));
      this.wudomain = data.wudomain;
      this.url = data.url;
      cache.set('LOGININFO', data); // 对所有龙湖白名单域名种cookie，并前往服务页面地址

      this.buryCookiesAndToClient(this.domains, this.wudomain, this.url); // 埋点及APM初始化

      this.initZhugeAndApm(data.account || this.loginForm.phone);
      this.$utils.loginZhuge('web-点击-登录页-登录成功', '短信验证码登录');
    },

    /**
     * @func 登录页面的错误处理
     * @param message 错误信息
     */
    handleLoginError: function handleLoginError(message) {
      this.showCheckPic = false;
      this.loginForm.picNum = '';
      this.loginForm.code = '';
      this.count.picNum = false;
      this.count.code = false;
      this.getPicCodeAjax();
      message && this.$message.error(message);
      this.$utils.loginZhuge('web-点击-登录页-登录失败', '短信验证码登录');
      console.log('登录页-短信验证码登录失败：', message);
    },

    /**
     * @func 切换账号密码登录
     */
    changeType: function changeType() {
      this.$store.commit('login/SET_LOGINTYPE', 'userName');
      this.$store.commit('login/SET_QRLOGIN', false);
    },

    /**
     * @func 切换二维码登录
     * @desc 如果是二维码登录，需要刷新二维码图片
     */
    loginTypeToggle: function loginTypeToggle() {
      // 更新是否为二维码登录状态
      this.$store.commit('login/SET_QRLOGIN', !this.isQrLogin); // 短信验证码登录，更新图片验证吗

      !this.isQrLogin && this.getCountryCode();
      !this.isQrLogin && this.getPicCodeAjax(); // 如果二维码处在失效状态，刷新二维码

      if (this.isQrLogin) {
        if (this.qrCodeExpired) {
          this.refreshQr();
        } else {
          // 传autoRefreash解决在进入短信登录页时未失效，切回二维码登录时二维码已经失效，需要自动刷新
          this.checkQrResult({
            autoRefreash: true
          });
        }
      }
    },

    /**
     * @func btoa：创建base-64编码的字符串
     * @func Uint8Array：创建一个8位无符号整型数组
     */
    toBase64: function toBase64(data) {
      // 创建可下标访问的数组
      var arr = new Uint8Array(data);
      var result = arr.reduce(function (prev, curr) {
        return prev + String.fromCharCode(curr);
      }, '');
      return btoa(result);
    },
    //点击用户头像向客户端拿key
    onUserLogin: function onUserLogin() {
      var env = process.env.VUE_APP_MODE;
      getSsoAuth(env);
    },
    //头像登陆
    qlogins: function qlogins() {
      var _this10 = this;

      this.$utils.loginZhuge('web-点击-登录页-快速登录');

      var _parseUrl2 = parseUrl(window.location.href),
          service = _parseUrl2.service;

      qlogin({
        loginKey: this.loginKey,
        service: service
      }).then(function (res) {
        console.log('头像登陆', res);
        var code = res.code,
            data = res.data;

        if (code === '1') {
          // 登录成功
          if (data && data.redirectUrl) {
            _this10.$utils.loginZhuge('web-点击-登录页-登录成功', '快速登录');

            window.location.href = data.redirectUrl;
          }
        } else {
          startLinkInitPc();

          _this10.$utils.loginZhuge('web-点击-登录页-登录失败', '快速登录');
        }
      }).catch(function (error) {
        console.log(error);
        startLinkInitPc();

        _this10.$utils.loginZhuge('web-点击-登录页-登录失败', '快速登录');
      });
    }
  }
};